import { c as _c } from "react/compiler-runtime";
import { AddToCurrentCartFailedError, AddToCurrentCartSucceededResult } from '../../store/carts/CartsState';
import { RootState } from '../../store/RootState';
import selectAddToCurrentCartFailedReason from '@spa/lib/store/carts/selectors/selectAddToCurrentCartFailedReason';
import selectFailedAddToCurrentCartActionIds from '@spa/lib/store/carts/selectors/selectFailedAddToCurrentCartActionIds';
import selectSucceededAddToCurrentCartResults from '@spa/lib/store/carts/selectors/selectSucceededAddToCurrentCartResults';
import { useSelector } from 'react-redux';
import { useState } from 'react';
export interface LastAddToCurrentCartResult {
  readonly succeeded: AddToCurrentCartSucceededResult | null;
  readonly failed: boolean;
  readonly failedReason?: AddToCurrentCartFailedError;
}
export type AddActionIdFunction = (actionIdToAdd: number) => void;
export interface LastAddToCurrentCartResponse {
  readonly result: LastAddToCurrentCartResult;
  readonly addRequestedActionId: AddActionIdFunction;
}
const useLastAddToCurrentCartResult = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [addToCurrentCartRequestedActionIds, setAddToCurrentCartRequestedActionIds] = useState(t0);
  const succeededAddToCurrentCartResults = useSelector(selectSucceededAddToCurrentCartResults);
  const failedAddToCurrentCartActionIds = useSelector(selectFailedAddToCurrentCartActionIds);
  const lastAddToCurrentCartRequestActionId = addToCurrentCartRequestedActionIds[addToCurrentCartRequestedActionIds.length - 1] ?? null;
  let t1;
  if ($[1] !== lastAddToCurrentCartRequestActionId || $[2] !== succeededAddToCurrentCartResults) {
    t1 = succeededAddToCurrentCartResults.find(result => result.requestedActionId === lastAddToCurrentCartRequestActionId) ?? null;
    $[1] = lastAddToCurrentCartRequestActionId;
    $[2] = succeededAddToCurrentCartResults;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const lastAddToCurrentCartSucceededResult = t1;
  let t2;
  if ($[4] !== failedAddToCurrentCartActionIds || $[5] !== lastAddToCurrentCartRequestActionId) {
    t2 = failedAddToCurrentCartActionIds.includes(lastAddToCurrentCartRequestActionId);
    $[4] = failedAddToCurrentCartActionIds;
    $[5] = lastAddToCurrentCartRequestActionId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const lastAddToCurrentCartFailed = t2;
  let t3;
  if ($[7] !== lastAddToCurrentCartRequestActionId) {
    t3 = state => selectAddToCurrentCartFailedReason(state, lastAddToCurrentCartRequestActionId);
    $[7] = lastAddToCurrentCartRequestActionId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const lastAddToCurrentCartFailedReason = useSelector(t3);
  let t4;
  if ($[9] !== addToCurrentCartRequestedActionIds) {
    t4 = actionIdToAdd => {
      setAddToCurrentCartRequestedActionIds([...addToCurrentCartRequestedActionIds, actionIdToAdd]);
    };
    $[9] = addToCurrentCartRequestedActionIds;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== lastAddToCurrentCartFailed || $[12] !== lastAddToCurrentCartFailedReason || $[13] !== lastAddToCurrentCartSucceededResult) {
    t5 = {
      succeeded: lastAddToCurrentCartSucceededResult,
      failed: lastAddToCurrentCartFailed,
      failedReason: lastAddToCurrentCartFailedReason
    };
    $[11] = lastAddToCurrentCartFailed;
    $[12] = lastAddToCurrentCartFailedReason;
    $[13] = lastAddToCurrentCartSucceededResult;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = {
      addRequestedActionId: t4,
      result: t5
    };
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default useLastAddToCurrentCartResult;